import { updateContentState } from "../../reducers/contentSlice"
import { fetchWBTokenStatus } from "../../reducers/wbTokenSlice"
import { updateFeedShopsState } from "../../reducers/feedShopsSlice"
import { getOrdersState, updateStorages } from "../../reducers/ordersReducer"
import { updateReportState } from "../../reducers/reportsSlice"
import { updateSettingsState } from "../../reducers/settingsReducer"
import { updateShopsState } from "../../reducers/shopsSlice"
import { updateSamsonState } from "../../reducers/updateStocksSamson"
import { updateStoksICONState } from "../../reducers/updateStoksIcon"
import { updateKatrenStoksState } from "../../reducers/updateStoksKatren"
import { updateMetroState } from "../../reducers/updateStoksMetro"
import {
  getPodrOrders,
  updateStoksPodruzhkaState,
} from "../../reducers/updateStoksPodruzhka"
import { AppDispatch } from "../../store"
import { WSocketService } from "./WSocketService"

let registeredListener: ((messageData: any) => void) | null = null

export const subscribeChangedThunk = () => (dispatch: AppDispatch) => {
  if (registeredListener) {
    WSocketService.unsubscribe("changed", registeredListener)
    registeredListener = null
  }

  const listener = (messageData: any) => {
    const { key } = messageData || {}
    if (key) {
      switch (key) {
        case "settings":
          dispatch(updateSettingsState())
          break
        case "katrenUpdateStoksState":
          dispatch(updateKatrenStoksState())
          break
        case "iconUpdateStoksState":
          dispatch(updateStoksICONState())
          break
        case "podrUpdateStoksState":
          dispatch(updateStoksPodruzhkaState())
          break
        case "podruzhkaBasket":
          dispatch(getPodrOrders())
          break
        case "metroUpdateStoksState":
          dispatch(updateMetroState())
          break
        case "ordersStore":
          dispatch(getOrdersState())
          break
        case "samsonoptState":
          dispatch(updateSamsonState())
          break
        case "updateStoksState":
          dispatch(updateStorages())
          break
        case "reportState":
          dispatch(updateReportState())
          break
        case "contentState":
          dispatch(updateContentState())
          break
        case "feedShopState":
          dispatch(updateFeedShopsState())
          break
        case "shopState":
          dispatch(updateShopsState())
          break
        case "WBTokenState":
          dispatch(fetchWBTokenStatus())
          break
        default:
          console.log("unknown action key", key)
          break
      }
    }
  }

  registeredListener = listener
  WSocketService.subscribe("changed", listener)
}

export const unsubscribeChangedThunk = () => () => {
  if (registeredListener) {
    WSocketService.unsubscribe("changed", registeredListener)
    registeredListener = null
  }
}
